"use strict";

exports.__esModule = true;
var _UiDesignContext = require("./UiDesignContext");
Object.keys(_UiDesignContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UiDesignContext[key]) return;
  exports[key] = _UiDesignContext[key];
});
var _UiDesignProvider = require("./UiDesignProvider");
Object.keys(_UiDesignProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UiDesignProvider[key]) return;
  exports[key] = _UiDesignProvider[key];
});
var _resolveUiDesign = require("./resolveUiDesign");
Object.keys(_resolveUiDesign).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _resolveUiDesign[key]) return;
  exports[key] = _resolveUiDesign[key];
});
var _uiSwitch = require("./uiSwitch");
Object.keys(_uiSwitch).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _uiSwitch[key]) return;
  exports[key] = _uiSwitch[key];
});
var _useUiDesign = require("./useUiDesign");
Object.keys(_useUiDesign).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useUiDesign[key]) return;
  exports[key] = _useUiDesign[key];
});
var _modernOverlay = require("./modernOverlay");
Object.keys(_modernOverlay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _modernOverlay[key]) return;
  exports[key] = _modernOverlay[key];
});
var _ModernGlobalStyles = require("./ModernGlobalStyles");
Object.keys(_ModernGlobalStyles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ModernGlobalStyles[key]) return;
  exports[key] = _ModernGlobalStyles[key];
});
var _whenModern = require("./whenModern");
Object.keys(_whenModern).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _whenModern[key]) return;
  exports[key] = _whenModern[key];
});